<div class="container">
  <div class="content" style="padding-right: 2px">
    <div class="row header small">
      <div class="image-col">
        <img class="image" src="/images/logo.svg" alt="">
      </div>
      <div *ngIf="activeAccount" class="col-10 user-menu">
        <div class="dropdown">
          {{ activeAccount.username }}
          <em style="cursor: pointer" class="bi bi-caret-down-fill" id="dropdownMenuButton" data-bs-toggle="dropdown"
             aria-haspopup="true" aria-expanded="false"></em>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <li><a class="dropdown-item" (click)="logout()">Log out</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

